export const updates = [
  {
    title: "What Are The Property Laws In Pakistan",
    description: `Article 4 subsection 2 of the constitution of Islamic Republic of Pakistan provides that no action detrimental to the life, liberty, body, reputation or property of any person shall be taken except in accordance with law. This article of the constitution provides protection to all citizens of Pakistan with regards to their property rights.`,
    image: `property-law-updates.png`,
  },
  {
    title: "Significance Of DNA Evidence In Criminal Litigation",
    description: `DNA evidence has revolutionized the world of forensic sciences in technologically advanced countries. Many of them maintain DNA databases for the investigation of crimes. Many crimes that were once difficult to investigate due to lack of evidence are now being revisited, and offenders are being put behind bars.`,
    image: `criminal-law-updates.jpg`,
  },
  {
    title: "How To File A Complaint Against Cyber-Crime In Pakistan?",
    description: `If your Facebook page is hacked, or if someone has posted your pictures without your consent, or even if you think someone is spreading hatred online, you can simply go ahead and report such cyber -crimes to NR3C to get relief that’s mandated by law now. `,
    image: `cyber-crime-updates.jpg`,
  },
  {
    title: "What Are The Property Laws In Pakistan",
    description: `Article 4 subsection 2 of the constitution of Islamic Republic of Pakistan provides that no action detrimental to the life, liberty, body, reputation or property of any person shall be taken except in accordance with law. This article of the constitution provides protection to all citizens of Pakistan with regards to their property rights.`,
    image: `property-law.jpg`,
  },
];
